import { render, staticRenderFns } from "./PageFooterMultipleButtons.vue?vue&type=template&id=13a24c13"
import script from "./PageFooterMultipleButtons.vue?vue&type=script&lang=js"
export * from "./PageFooterMultipleButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports